import { createSelector } from 'reselect';

import * as defaultCoworkingLogo from 'shared/components/UI/Icons/defaultCoworkingLogo.svg';

import { getCoworkingOperator } from './getCoworkingOperator';

export const coworkingOperatorLogoSelector = createSelector(
  getCoworkingOperator,
  operator => operator?.logo ?? defaultCoworkingLogo,
);
